import { render, staticRenderFns } from "./BlocoVisualizarDados.vue?vue&type=template&id=0c212ed1&scoped=true&lang=pug"
import script from "./BlocoVisualizarDados.vue?vue&type=script&lang=js"
export * from "./BlocoVisualizarDados.vue?vue&type=script&lang=js"
import style0 from "./BlocoVisualizarDados.vue?vue&type=style&index=0&id=0c212ed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c212ed1",
  null
  
)

export default component.exports